import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './Section.module.css';

export const Section = ({
  name,
  children,
  className,
  hasActiveFilters,
}: {
  name: string;
  children: JSX.Element | JSX.Element[];
  className?: string;
  hasActiveFilters?: boolean;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasCheckedChildCheckboxes =
    Array.isArray(children) &&
    (children.some(child => child?.props?.isChecked) ||
      !!children
        ?.map(c => c.props)
        .filter(
          secondLevelChild =>
            secondLevelChild?.children &&
            Array.isArray(secondLevelChild.children) &&
            secondLevelChild.children?.some(
              thirdLevelChild => thirdLevelChild?.props?.isChecked,
            ),
        ).length);

  const activeFiltersPresent = hasCheckedChildCheckboxes || hasActiveFilters;

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={classNames(styles.title, {
          [styles.titleExpanded]: isExpanded,
        })}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className={styles.heading}>
          {name}
          {activeFiltersPresent && <div className={styles.activeDot} />}
        </div>
        {isExpanded ? (
          <CaretUpFilled className={styles.caret} />
        ) : (
          <CaretDownFilled className={styles.caret} />
        )}
      </div>
      {isExpanded && children}
    </div>
  );
};
